/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-26 17:21:58
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2022-10-22 16:52:56
 * @FilePath: /njyx-frontend-pc/packages/share/utils/addTopNavPath.ts
 * @Description:增加顶部路径的函数
 *
 */

import localforage from "localforage";
export default function addPath(
  path: string,
  name: string,
  query?: any,
  btnList?: any
) {
  //   let localCachePath = localStorage.getItem("menuPath");
  //   if (localCachePath) {
  //     let pathArr = JSON.parse(localCachePath);
  //     if (pathArr.every((item: Record<string, any>) => item.url != path)) {
  //       pathArr.push({ url: path, name: name, query: query });
  //     }

  //     const tabItem = new CustomEvent("updateMenuPath", { detail: pathArr });
  //     window.dispatchEvent(tabItem);
  //   }

  let obj = {
    url: path,
    name: name,
    query: query,
    btnList: btnList,
    isClick: true,
    hover: false,
  };

  localforage.getItem("allActive3LevelMenuData").then((data: any) => {
    if (data && data.length) {
      data.forEach((item: any) => (item.isClick = false));
      let curIndex: number = -1;
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        if (item.url == path) {
          curIndex = i;
          data.splice(i, 1, obj);
          break;
        }
      }
      if (curIndex == -1) {
        data.push(obj);
      }
    } else {
      data = [];
      data.push(obj);
    }
    localforage.setItem("allActive3LevelMenuData", data).then((value: any) => {
      const tabItem = new CustomEvent("allActive3LevelMenuData", {
        detail: { allActive3LevelMenuData: value },
      });
      window.dispatchEvent(tabItem);
    });
  });
}
